<script setup lang="ts">
import { computed, ref } from 'vue';
import { VForm, VAutocomplete, VSelect, VBtn } from 'vuetify/components';
import { useI18n } from 'vue-i18n';

export type ProjectSelect = {
    name: string;
    id: string;
};

export type LinkDeliverableFormValues = {
    deliverableId: string;
};

const { t } = useI18n({
    messages: {
        nl: {
            project_label: '@:subproject',
            deliverable_label: '@:deliverable',
            submit: 'Koppelen',
        },
        en: {
            project_label: '@:subproject',
            deliverable_label: '@:deliverable',
            submit: 'Link',
        },
    },
});

const isLoadingDeliverables = ref(false);

defineProps<{
    projects: ProjectSelect[];
    deliverables: ProjectSelect[];
}>();

const emit = defineEmits<{
    submit: [values: LinkDeliverableFormValues];
    cancel: [];
}>();

const disabled = computed(() => {
    return false;
});

const selectedProject = defineModel<string>();

const selectedDeliverable = ref<string | undefined>(undefined);

function onSubmit() {
    if (!selectedDeliverable.value) return;
    emit('submit', {
        deliverableId: selectedDeliverable.value,
    });
}
</script>

<template>
    <VForm class="d-flex flex-column ga-3" :disabled @submit.prevent="onSubmit">
        <VAutocomplete
            v-model="selectedProject"
            :label="t('project_label')"
            :items="projects"
            auto-select-first
            item-title="name"
            item-value="id"
        ></VAutocomplete>

        <VSelect
            v-model="selectedDeliverable"
            :label="t('deliverable_label')"
            :items="deliverables"
            :loading="isLoadingDeliverables"
            item-title="name"
            item-value="id"
        />

        <div class="d-flex justify-end">
            <VBtn variant="text" @click="emit('cancel')">{{
                t('cancel')
            }}</VBtn>
            <VBtn
                :disabled="!selectedDeliverable"
                type="submit"
                variant="elevated"
                >{{ t('submit') }}</VBtn
            >
        </div>
    </VForm>
</template>
